import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PerformerContractEditor.html?raw';
import lang from 'dojo/_base/lang';

import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import _GlobalSelectEntityDialogsMixin from '../../../../moreCore/UI/Container/uiFrame';

import { TabContainer } from "../../../../moreCore/_loadingHelpers/Tabbing";

import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../../moreCore/Tools/EntityStore';
import GenericEntityView from '../../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { VAMclassNames } from "../../../_loadingHelpers/VAM";

interface BookingListEntry {
    ID: string,
    Classname: string,
    ref_ev_planning: {
        ID: string,
        Classname: string,
        gDisp_1: string,
        ref_ev_activity_status: {
            code: string
        },
        ref_ev_booking_status: {
            code: string,
            coloration: any
        }
    }
}
interface BookingBase {
    ID: string,
    Classname: string,
    gDisp_1: string,
    ref_ev_activity_status: {
        code: string
    },
    ref_ev_booking_status: {
        code: string,
        coloration: any
    }
}
class PerformerContractEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private allowButtons = false;

    private inputContractAddress: MdsLax<InstanceType<typeof HintBox>>;
    private inputContractPerson: MdsLax<InstanceType<typeof HintBox>>;
    private inputPerformer: MdsLax<InstanceType<typeof HintBox>>;
    private inputTaxAddress: MdsLax<InstanceType<typeof HintBox>>;
    private inputRepresentedBy: MdsLax<InstanceType<typeof HintBox>>;
    private inputRepresentedByContactPerson: MdsLax<InstanceType<typeof HintBox>>;
    private inputCurrency: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputBankAccount: MdsLax<InstanceType<typeof HintBox>>;

    private expanderFee: MdsLax<InstanceType<typeof ExpandableSection>>;
    private expanderBank: MdsLax<InstanceType<typeof ExpandableSection>>;
    private expanderBookingList: MdsLax<InstanceType<typeof ExpandableSection>>;
    private addBookingInput: MdsLax<InstanceType<typeof HintBox>>;
    private bookingTable: MdsLax<InstanceType<typeof StaticTable>>;
    private bookingTableContainer: HTMLElement;
    private store: MdsLax<InstanceType<typeof EntityStore<BookingListEntry>>>;
    private managedInputs: Array<{ mode: string, attrName: string, input: MdsLax<InstanceType<typeof HintBox>> }> = [];

    private sectionEntityView_Top: HTMLElement;
    private EntityViewContainer_Top: HTMLElement;
    private sectionEntityView_MiddleTop: HTMLElement;
    private EntityViewContainer_MiddleTop: HTMLElement;
    private sectionEntityView_Bottom: HTMLElement;
    private EntityViewContainer_Bottom: HTMLElement;

    private _setupEntityViews() {

        this.hideNode(this.sectionEntityView_Top);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_Top);

        this.hideNode(this.sectionEntityView_MiddleTop);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_MiddleTop);

        this.UiModder.domConstruct.empty(this.EntityViewContainer_Bottom);
        this.hideNode(this.sectionEntityView_Bottom);

        if (!this.entityId) return;

        if (this.hasFeature("PerformerContract/EntityViewInEditor_Top")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.performer_contract,
                this.getDisplayname(),
                "",
                this.EntityViewContainer_Top,
                null,
                "documentEditor_Top");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Top));

        }
        if (this.hasFeature("PerformerContract/EntityViewInEditor_MiddleTop")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.performer_contract,
                this.getDisplayname(),
                "",
                this.EntityViewContainer_MiddleTop,
                null,
                "documentEditor_MiddleTop");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_MiddleTop));

        }
        if (this.hasFeature("PerformerContract/EntityViewInEditor_Bottom")) {
            this.hideNode(this.sectionEntityView_Bottom, false);

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.performer_contract,
                this.getDisplayname(),
                "",
                this.EntityViewContainer_Bottom,
                null,
                "documentEditor_Bottom");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Bottom));

        }
    }

    setup(entity: DocumentEntity, tabContainer?: MdsLax<InstanceType<typeof TabContainer>>, node?: HTMLElement) {
        let heading;

        this.setData(entity);
        this.setStartupState("ready");

        if (node) {
            this.show("node", node, heading);
        } else if (tabContainer) {
            this.show("tab", heading, tabContainer.name);
        }
        else {
            this.show("dlg", heading);
        }

        if (this.allowButtons) this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false, "primary");
    }

    //LOAD
    private _loadEntity(entityId: string): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        this.RequestManager.callfunction(
            "Webtool_API_Document__PerformerContractEditor_LoadEntity",
            { ID: entityId },
            lang.hitch(this, this._onLoadEntityResponse),
            lang.hitch(this, this._onLoadEntityError));
    }

    private _onLoadEntityResponse(response: any): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        response.is_new = false;
        this.setData(response);
    }

    private _onLoadEntityError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
    }

    //SAVE
    private _onClickSave(): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);

        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let isNew = this.getAttributeValue("is_new");
        let changedData = this.getChangedData();
        this.RequestManager.callfunction(
            "Webtool_API_Document__PerformerContractEditor_SaveEntity",
            { ID: entityId, Classname: classname, is_new: isNew, changedData: changedData },
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.emit("saved");
        this.showToast("Editor_Success_Save", "fas fa-check");
        this._loadEntity(response.entityId);
    }

    private _onSaveError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Save", "fas fa-warning-triangle");
    }

    //ROLLBACK
    private _onClickRollback(e: MouseEvent): void {
        this.rollback();
    }

    //RELOAD
    private _onClickReload(e: MouseEvent): void {
        let entity = this.getAttributeValue("___root");
        this._loadEntity(entity.ID);
    }

    //DELETE
    private _onClickDelete(e: MouseEvent): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        this.RequestManager.callfunction(
            "Webtool_API_Document__PerformerContractEditor_DeleteEntity",
            { ID: entityId, Classname: classname },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError));
    }

    private _onDeleteResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.close();
        this.showToast("Editor_Success_Delete", "fas fa-check");
    }

    private _onDeleteError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Delete", "fas fa-warning-triangle");
    }


    //BUTTONS
    private _deactivateDataButtons(deactivate: boolean, deactivateAll?: boolean): void {
        this.requestContextButtonDisable("save", deactivate);
        this.requestContextButtonDisable("rollback", deactivate);
        if (deactivateAll) {
            this.requestContextButtonDisable("delete", deactivate);
            this.requestContextButtonDisable("reload", deactivate);
        }
    }

    //STATEFULSECTION
    protected onDirtyChange(newState: boolean) {
        this._deactivateDataButtons(!newState);
        this.setDirtyMarker(newState);
    }

    protected _onChanged(attribute: string, value: any) {

        switch (attribute) {
            case "ref_address":
                this._manageAdditionalRequestParameters("contractPerson")
                break;
            case "ref_address_perfomer":
                this._manageAdditionalRequestParameters("taxAddress")
                this._manageAdditionalRequestParameters("bankAccount")
                break;
            case "ref_represented_by":
                this._manageAdditionalRequestParameters("representedByContactPerson")
                break;
            case "ref_currency":
                if (typeof value == "object") this.setAttributeValue("ref_currency.code", value["code"], true)
            case "fee_value":
            case "accomodation_cost_value":
            case "travel_cost_value":
            case "special_cost_value":
            case "price_total_incl_VAT":
            case "exchange_rate":
                this.checkExpadnerMarkings("fee");
                break;
            case "ref_bank_account":
                if (value) {
                    if (typeof value == "object") this.setAttributeValue("ref_bank_account.account_name", value["account_name"], true)
                    if (typeof value == "object") this.setAttributeValue("ref_bank_account.c_bankname", value["c_bankname"], true)
                    if (typeof value == "object") this.setAttributeValue("ref_bank_account.c_banknumber", value["c_banknumber"], true)
                    if (typeof value == "object") this.setAttributeValue("ref_bank_account.IBAN", value["IBAN"], true)
                    if (typeof value == "object") this.setAttributeValue("ref_bank_account.ref_bank.bank_BIC", value["ref_bank"]?.bank_BIC, true)
                } else {
                    this.setAttributeValue("ref_bank_account.account_name", null, true)
                    this.setAttributeValue("ref_bank_account.c_bankname", null, true)
                    this.setAttributeValue("ref_bank_account.c_banknumber", null, true)
                    this.setAttributeValue("ref_bank_account.IBAN", null, true)
                    this.setAttributeValue("ref_bank_account.ref_bank.bank_BIC", null, true)
                }
                this.checkExpadnerMarkings("bank");
                break;
        }

        this.emit("changed", this.changedData);
        //this.
    }

    private _manageAdditionalRequestParameters(mode?: string) {

        this.managedInputs.forEach(mi => {

            if (!mode || mode === mi.mode) {
                let value = this.getAttributeValue(mi.attrName);
                let id;
                if (value && typeof value == "object") id = value.ID;
                else id = value;
                mi.input.addAdditionalRequestParameter("mode", mi.mode);
                mi.input.addAdditionalRequestParameter(mi.attrName, id);
            }
        })
    }
    private setupBookingTable() {
        if (this.bookingTable && !this.bookingTable._destroyed) this.bookingTable.destroy();

        let array: any[] = this.getAttributeValue("EL_ht_doc_evplanning_document");
        this.bookingTable = new StaticTable();
        this.bookingTable.setLayout(this.getAttributeValue("tableLayouts")[0]);
        this.store = new EntityStore();
        this.store.setup(array);

        this.bookingTable.addDefaultRowActionButton("delete", lang.hitch(this, this.updateBookingTable), lang.hitch(this, this.isEnabled));

        this.bookingTable.placeAt(this.bookingTableContainer);

        this.updateBookingTable();
    }

    private _onChange_addBookingInput() {
        let value = this.addBookingInput.getValue() as BookingBase;

        if (this.store.isEntityExisting(value.ID, "ref_ev_planning.ID")) {
            this.showToast({
                title: this.translate("DocumentEditor_Termin_Toast_ExistInList_details"),
                message: `**${value.gDisp_1}**  ${this.translate("DocumentEditor_Termin_Toast_ExistInList_details")}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            });
            this.addBookingInput.setValue(null, true);
            return;
        }

        if (value != null) {
            let fakeBookingEntry: Partial<BookingListEntry> = {
                ID: (Math.random() * 100000).toString(),
                ref_ev_planning: value
            }

            this.store.addEntry(fakeBookingEntry as any);

            this.addBookingInput.setValue(null, true);
        }

        this.updateBookingTable();
    }

    private updateBookingTable() {

        this.setAttributeValue("bookingTableDiff", this.store.getDiffData(), true);
        
        this.bookingTable.setupFromStore(this.store);
        //this.bookingTable.runAdditionalSorting();
        this.store.getCurrentCompleteCount() > 0 ? this.expanderBookingList.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderBookingList.setMarking(ExpandableSectionMarkings.default);
    }

    private checkExpadnerMarkings(mode: "bank"|"fee" = null) {

        switch (mode) {
            case "bank":
                this.getAttributeValue("ref_bank_account") != null ? this.expanderBank.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderBank.setMarking(ExpandableSectionMarkings.default)
                break;
            case "fee":
                let bool = this.getAttributeValue("ref_currency")
                    || this.getAttributeValue("fee_value")
                    || this.getAttributeValue("accomodation_cost_value")
                    || this.getAttributeValue("travel_cost_value")
                    || this.getAttributeValue("special_cost_value")
                    || this.getAttributeValue("price_total_incl_VAT")
                    || this.getAttributeValue("exchange_rate");
                bool ? this.expanderFee.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderFee.setMarking(ExpandableSectionMarkings.default) 
                break;
            default:
                this.checkExpadnerMarkings("bank");
                this.checkExpadnerMarkings("fee");
        }
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this._manageAdditionalRequestParameters();

        this.setupBookingTable();

        let isNew = this.getAttributeValue("is_new");
        if (!isNew) {
            if (this.allowButtons) this.createDefaultButton("delete", lang.hitch(this, this._onClickDelete), true, "secondary");
            if (this.allowButtons) this.createDefaultButton("rollback", lang.hitch(this, this._onClickRollback), false, "secondary");
            if (this.allowButtons) this.createDefaultButton("reload", lang.hitch(this, this._onClickReload), true, "primary");
            this.changeInternalName("PerformerContractEditor_Editor_" + this.getAttributeValue("ID"));

            let refCast = this.getAttributeValue("ref_ev_cast_ev_project");
            if (refCast) this.inputPerformer.setReadonly(true); 
            //this.setTitles(`${this.translate("Document_Heading_PerformerContractEditor")}: ${this.getAttributeValue("ATTRIBUTENAME")}`);
        } else {

        }
        this._deactivateDataButtons(true);
        this.checkExpadnerMarkings();

        this._setupEntityViews();
    }

    setReadonly(readonly?: "initial" | boolean) {
        super.setReadonly.apply(this, arguments as any);

        if (this.addBookingInput && !this.addBookingInput._destroyed) this.addBookingInput.destroy();
    }

    isEnabled(): boolean {
        return !this.isReadonly();
    }

    //UIFRAMEMIXIN
    //UIFRAMEMIXIN
    _onCloseRequest() {
        let hasChanged = this.isDirty() === true;

        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translate("Document_PerformerContractEditor_AskSavePendingChanges"),
                this.translate("General_PendingChanges") + " - " + this.title,
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.emit("notSaved");
            this.close();
        } else if (result == 0) { // cancel
            this.emit("canceled");
        }
        else {
            this._onClickSave();
            this.on("saved", lang.hitch(this, this.close));
        }
    }

    private _onClickSEDButton(mode: string, evt: MouseEvent) {
        let additionalData = null;

        switch (mode) {
            case "contractPerson":
                additionalData = this.inputContractPerson.getAdditionalRequestParams(true);
                break;
            case "taxAddress":
                additionalData = this.inputTaxAddress.getAdditionalRequestParams(true);
                break;
            case "representedByContactPerson":
                additionalData = this.inputRepresentedByContactPerson.getAdditionalRequestParams(true);
                break;
            case "bankAccount":
                additionalData = this.inputBankAccount.getAdditionalRequestParams(true);
                break;
            case "booking":
                additionalData = this.addBookingInput.getAdditionalRequestParams(true);
                break;
            default:
        }

        this.loadSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback), null, additionalData);
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<DocumentAddress>>) {
        let entity;
        if (items && items.length >= 0) entity = items[0].entry.data;
        else return;

        switch (mode) {
            case "contractAddress":
                this.setAttributeValue("ref_address", entity);
                break;
            case "performerAddress":
                this.setAttributeValue("ref_address_perfomer", entity);
                break;
            case "representedByAddress":
                this.setAttributeValue("ref_represented_by", entity);
                break;
            case "contractPerson":
                this.setAttributeValue("ref_contact_person", entity);
                break;
            case "taxAddress":
                this.setAttributeValue("ref_tax_address", entity);
                break;
            case "representedByContactPerson":
                this.setAttributeValue("ref_contact_person_represent", entity);
                break;
            case "bankAccount":
                this.setAttributeValue("ref_bank_account", entity);
                break;
            case "booking":
                items.forEach(i => {
                    this.addBookingInput.setValue(i.entry.data);
                });                
                break;
        }
    }

    private _refreshRequestParameters() {

        //this.inputContractPerson -> ref_address
        //this.inputTaxAddress -> ref_address_perfomer
        //this.inputRepresentedByContactPerson -> ref_represented_by
    }

    //WIDGETBASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_Document__DocumentEditor_GetSEDConfig";

        this.addOnchanged("ref_address", lang.hitch(this, this._onChanged));
        this.addOnchanged("ref_address_perfomer", lang.hitch(this, this._onChanged));
        this.addOnchanged("ref_represented_by", lang.hitch(this, this._onChanged));
        this.addOnchanged("ref_currency", lang.hitch(this, this._onChanged));
        this.addOnchanged("fee_value", lang.hitch(this, this._onChanged));
        this.addOnchanged("accomodation_cost_value", lang.hitch(this, this._onChanged));
        this.addOnchanged("travel_cost_value", lang.hitch(this, this._onChanged));
        this.addOnchanged("special_cost_value", lang.hitch(this, this._onChanged));
        this.addOnchanged("price_total_incl_VAT", lang.hitch(this, this._onChanged));
        this.addOnchanged("exchange_rate", lang.hitch(this, this._onChanged));
        this.addOnchanged("ref_bank_account", lang.hitch(this, this._onChanged));

        this.inputContractAddress.addInlineButton(lang.hitch(this, this._onClickSEDButton, "contractAddress"));
        this.inputPerformer.addInlineButton(lang.hitch(this, this._onClickSEDButton, "performerAddress"));
        this.inputRepresentedBy.addInlineButton(lang.hitch(this, this._onClickSEDButton, "representedByAddress"));

        this.inputContractPerson.addInlineButton(lang.hitch(this, this._onClickSEDButton, "contractPerson"));
        this.inputTaxAddress.addInlineButton(lang.hitch(this, this._onClickSEDButton, "taxAddress"));
        this.inputRepresentedByContactPerson.addInlineButton(lang.hitch(this, this._onClickSEDButton, "representedByContactPerson"));

        this.inputBankAccount.addInlineButton(lang.hitch(this, this._onClickSEDButton, "bankAccount"));

        this.addBookingInput.addInlineButton(lang.hitch(this, this._onClickSEDButton, "booking"));

        this.managedInputs.push({ mode: "contractPerson", attrName: "ref_address", input: this.inputContractPerson });
        this.managedInputs.push({ mode: "taxAddress", attrName: "ref_address_perfomer", input: this.inputTaxAddress });
        this.managedInputs.push({ mode: "representedByContactPerson", attrName: "ref_represented_by", input: this.inputRepresentedByContactPerson });
        this.managedInputs.push({ mode: "bankAccount", attrName: "ref_address_perfomer", input: this.inputBankAccount });
        this.managedInputs.push({ mode: "booking", attrName: "ref_ev_project", input: this.addBookingInput });
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PerformerContractEditor);